import { Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';
import { VentaDiaria } from '../../inicio.service';
import { SemanaData } from '../../shared/types';
import { formatShort, formatMoney } from '../../shared/format';
import { exportarElemento } from '../../shared/export';
import { calcularSemanas } from '../../shared/metrics';

@Component({
  selector: 'app-venta-semanal',
  templateUrl: './venta-semanal.component.html',
  styleUrls: ['./venta-semanal.component.scss']
})
export class VentaSemanalComponent implements OnChanges {
  @Input() ventasDiarias: VentaDiaria[] = [];
  @Input() ventasAnterior: VentaDiaria[] = [];
  @Input() desde!: Date;
  @Input() hasta!: Date;
  @ViewChild('exportRef') exportRef!: ElementRef;

  semanas: SemanaData[] = [];

  formatShort = formatShort;
  formatMoney = formatMoney;

  ngOnChanges() {
    if (!this.desde || !this.hasta) return;
    this.semanas = calcularSemanas(this.ventasDiarias, this.ventasAnterior, this.desde, this.hasta);
  }

  exportar(tipo: 'png' | 'pdf') {
    exportarElemento(this.exportRef.nativeElement, tipo, 'venta-semanal', ['.export-actions']);
  }
}
